import { SkeletonLoader } from '@kanda-libs/ks-design-library';

import GoogleLogo from '../../assets/g-logo.png';

interface ViewComponentProps {
  /**
   * Disabled state for social buttons
   */
  socialDisabled?: boolean;
  /**
   * Function to sign in with Google
   */
  signInWithGoogle?: () => unknown;
  /**
   * is loading state
   */
  isLoading?: boolean;
}

const ViewComponent = ({
  isLoading,
  socialDisabled,
  signInWithGoogle,
}: ViewComponentProps) => (
  <SkeletonLoader
    isLoading={isLoading}
    width="100%"
    height={44}
    wrapperClassName="w-full"
    afterLoading={
      <button
        className="flex flex-row w-full font-roboto h-12 p-3 rounded social-shadow mb-4 md:mb-0 md:mr-4"
        type="button"
        disabled={socialDisabled}
        onClick={signInWithGoogle}
      >
        <img src={GoogleLogo} alt="g-logo" className="w-6 h-6 mr-3" />
        <p className="text-14-22 my-auto whitespace-nowrap">
          Sign in with Google
        </p>
      </button>
    }
  />
);

ViewComponent.defaultProps = {
  isLoading: false,
  socialDisabled: undefined,
  signInWithGoogle: undefined,
};

ViewComponent.displayName = 'Login-Google-view';

export default ViewComponent;
